<template>
    <Head title="Register" />

    <BreezeValidationErrors class="mb-4" />

    <form @submit.prevent="submit">

     <div class="flex flex-column justify-content-center align-items-stretch guest-forms w-9 md:w-9 lg:w-4  mx-auto">
            <h1 class="text-center">CREA IL TUO ACCOUNT</h1>
        <div class="grid">
            <div class="col-12 md:col-6">
                <span class="p-float-label mb-4 w-full">
                <InputText id="username" type="text" v-model="form.name" required class="w-full" />
                <label for="username">Nome</label>
                </span>
            </div>
            <div class="col-12 md:col-6">
                <span class="p-float-label mb-4 w-full">
                <InputText id="surname" type="text" v-model="form.surname" required class="w-full" />
                <label for="surname">Cognome</label>
                </span>
            </div>
        </div>
        <div class="grid">
            <div class="col-12 md:col-6">
                <span class="p-float-label mb-4 w-full">
                <InputText id="email" type="email" v-model="form.email" required class="w-full"/>
                <label for="email" >Email</label>
                </span>
            </div>
            <div class="col-12 md:col-6">
            <span class="p-float-label mb-4 w-full">
	        <InputText id="confirmemail" type="email" v-model="form.email_confirmation" required class="w-full"/>
	        <label for="confirmemail" >Conferma Email</label>
            </span>
            </div>
        </div>
        <div class="grid">
            <div class="col-12 md:col-6">
                <span class="p-float-label mb-4 w-full">
                <InputText id="password" type="password" v-model="form.password" required class="w-full"/>
                <label for="password" >Password</label>
                </span>
            </div>
            <div class="col-12 md:col-6">
                <span class="p-float-label w-full">
                <InputText id="confirmpwd" type="password" v-model="form.password_confirmation" required class="w-full"/>
                <label for="confirmpwd" >Conferma Password</label>
                </span>
            </div>
        </div>
            <Button label="REGISTRATI" class="p-button-raised p-button-rounded p-button-secondary mt-4 w-full" :class="{ 'opacity-25': form.processing }" :disabled="form.processing" />

        <div class="text-center mt-4 w-full">
             <Link  class="underline text-sm  hover:text-gray-900" :href="route('login')">
                HO GIA' UN ACCOUNT
            </Link>
        </div>

       </div>



    </form>
</template>

<script>
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import BreezeButton from '@/Components/Button.vue'
import BreezeGuestLayout from '@/Layouts/Guest.vue'
import BreezeInput from '@/Components/Input.vue'
import BreezeLabel from '@/Components/Label.vue'
import BreezeValidationErrors from '@/Components/ValidationErrors.vue'
import { Head, Link } from '@inertiajs/inertia-vue3';

export default {
    layout: BreezeGuestLayout,

    components: {
        BreezeButton,
        BreezeInput,
        BreezeLabel,
        InputText,
        Button,
        BreezeValidationErrors,
        Head,
        Link,
    },

    data() {
        return {
            form: this.$inertia.form({
                name: '',
                email: '',
                password: '',
                password_confirmation: '',
                terms: false,
            })
        }
    },

    methods: {
        submit() {
            this.form.post(this.route('register'), {
                onFinish: () => this.form.reset('password', 'password_confirmation'),
            })
        }
    }
}
</script>
